'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Group, Stack, Text } from '@mantine/core';

// Types
import { PropsWithChildren } from 'react';
import { SearchSuggestionsSectionTitleProps } from './types';

// Style
import * as classes from './styles/index.css';
import { palette } from '@app/shared/ui-kit/colors';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
function SearchSuggestionsSection({
  children,
  title,
  totalCount,
  isRowDisplay,
}: PropsWithChildren<SearchSuggestionsSectionTitleProps>) {
  return (
    <Stack gap={7} align="flex-start">
      <Group gap={8} px="sm">
        <Text c={palette.blackroomLightGray5}>{title}</Text>
        <Text
          c={palette.blackroomLightGray5}
          bg="blackroomLightGray"
          span
          className={classes.fileCountBadge}
        >
          {totalCount}
        </Text>
      </Group>

      <Stack gap={6} align="flex-start" w="100%">
        {isRowDisplay ? <Group gap={10}>{children}</Group> : children}
      </Stack>
    </Stack>
  );
}

export default SearchSuggestionsSection;
